'use strict';
require('./AdminScaffolding.scss');
require('../BasicForm/BasicForm.scss');

const React = require('react'),
    PropTypes = React.PropTypes,
    {kebabCase} = require('lodash/string'),
    {filter, map} = require('lodash/collection'),
    {uniqueId} = require('lodash/util'),
    SessionStore = require('stores/SessionStore'),
    BasicFormChange = require('components/Commons/BasicForm/BasicFormChange'),
    BasicFormNew = require('components/Commons/BasicForm/BasicFormNew'),
    UserPermissionStore = require('stores/UserPermissionStore'),
    {IconButton, FontIcon} = require('material-ui'),
    {Navigation} = require('react-router');

const AdminScaffolding = React.createClass({displayName: "AdminScaffolding",

    mixins: [Navigation],

    propTypes: {
        additionalSubmitValue: PropTypes.object,
        additionalPreSubmitValidation: PropTypes.func,
        contextHolder: PropTypes.object,
        fetchItems: PropTypes.func,
        headerFields: (props, propName) => {
            const fields = props[propName];
            React.Children.forEach(fields, (child) => {
                if (kebabCase(child.type.displayName).indexOf('form-group') === -1) {
                    throw new Error('The children must be a `form-group` component.');
                }
            });
        },
        module: PropTypes.string,
        messages: PropTypes.object,
        addEnterKeyDown: PropTypes.func,
        onAdd: PropTypes.func.isRequired,
        onAddText: PropTypes.func,
        onChange: PropTypes.func.isRequired,
        onChangeText: PropTypes.func,
        onDelete: PropTypes.func.isRequired,
        onCancel: PropTypes.func.isRequired,
        onDeleteText: PropTypes.string,
        title: PropTypes.string,
        additionalButtons: PropTypes.array,
        value: PropTypes.object,
        isDeleteHidden: PropTypes.boolean,
        customClassName: PropTypes.string,
        breadcrumb: PropTypes.array,
        shouldFocusDidMount: PropTypes.bool,
        isSaving: PropTypes.bool,
        moduleName: PropTypes.string
    },

    getInitialState(){
        return {
            isValid: true
        };
    },

    goToHistory() {
        this.transitionTo('/history?selected-module=:module', {
            module: this.props.module
        });
    },

    shouldHidden(permissionTarget) {
        return SessionStore.isFullPaidVersion() ? !UserPermissionStore.shouldShow(this.props.moduleName, permissionTarget) : !SessionStore.isAdminUser();
    },

    render() {
        const {
            isSaving,
            shouldFocusDidMount,
            onDeleteText,
            addEnterKeyDown,
            onAddText,
            onChangeText,
            module,
            breadcrumb,
            customClassName,
            additionalPreSubmitValidation,
            additionalSubmitValue,
            isDark,
            title,
            headerFields,
            onAdd,
            onChange,
            onDelete,
            onCancel,
            value,
            fetchItems,
            messages,
            contextHolder,
            additionalButtons
        } = this.props;
        
        const additionalButtonsFiltered = SessionStore.isFullPaidVersion()
          ? SessionStore.hasAdminUserPermission()
          ? additionalButtons
          : filter(additionalButtons, button => UserPermissionStore.shouldShow(this.props.moduleName, button.permission))
          : additionalButtons;
        const additionalButtonChange = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, (button) => button.type === 'CHANGE'), (buttonEl) => buttonEl.el) : null;
        const additionalButtonNew = additionalButtonsFiltered ? map(filter(additionalButtonsFiltered, (button) => button.type === 'NEW'), (buttonEl) => buttonEl.el) : null;
        const formEl = value ? (
            React.createElement(BasicFormChange, {
                additionalPreSubmitValidation: additionalPreSubmitValidation, 
                isDark: isDark, 
                addEnterKeyDown: addEnterKeyDown, 
                title: title, 
                contextHolder: contextHolder, 
                messages: messages, 
                fetchItems: fetchItems, 
                value: value, 
                onChange: onChange, 
                onChangeText: onChangeText, 
                onCancel: onCancel, 
                onDelete: onDelete, 
                onDeleteText: onDeleteText, 
                additionalSubmitValue: additionalSubmitValue, 
                additionalButtons: additionalButtonChange, 
                isDeleteHidden:  onDelete === undefined || this.shouldHidden('DELETE'), 
                isSaveHidden:  onChange === undefined || this.shouldHidden('EDIT'), 
                breadcrumb: breadcrumb, 
                isValid: this.state.isValid, 
                shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount, 
                isSaving: isSaving
            }, 
                headerFields 
            )
        ) : (
            React.createElement(BasicFormNew, {
                additionalPreSubmitValidation: additionalPreSubmitValidation, 
                addEnterKeyDown: addEnterKeyDown, 
                isDark: isDark, 
                title: title, 
                contextHolder: contextHolder, 
                messages: messages, 
                onAdd: onAdd, 
                onAddText: onAddText, 
                fetchItems: fetchItems, 
                additionalSubmitValue: additionalSubmitValue, 
                additionalButtons: additionalButtonNew, 
                isAddHidden:  onAdd === undefined|| this.shouldHidden('NEW'), 
                breadcrumb: breadcrumb, 
                isValid: this.state.isValid, 
                shouldFocusDidMount: shouldFocusDidMount === undefined ? true : shouldFocusDidMount, 
                isSaving: isSaving
            }, 
                headerFields 
            )
        );

        const goToHistoryEl = module ? (
            React.createElement("div", {className: "admin-scaffolding-history"}, 
                React.createElement("small", null, t('label_history')), 
                React.createElement(IconButton, {onClick: this.goToHistory, className: "right-option-menu", touch: true}, 
                    React.createElement(FontIcon, {color: '#fff', className: "material-icons"}, "history")
                )
            )) : null;


        let className = 'admin-scaffolding';

        if (!this.state.isValid) {
            className += ' is-invalid';
        }

        if (!SessionStore.isFullPaidVersion()) {
            className += ' is-free-version';
        }

        return (
            React.createElement("div", {className: className}, 
                goToHistoryEl, 
                React.createElement("div", {key:  uniqueId('admin-scaffolding-header'), className: "admin-scaffolding-header"}, 
                    formEl 
                ), 
                React.createElement("div", {key:  uniqueId('admin-scaffolding-content'), 
                     className: `admin-scaffolding-content ${customClassName}`}, 
                     this.props.children
                )
            )
        );
    }

});

module.exports = AdminScaffolding;



/** WEBPACK FOOTER **
 ** ./src/components/Commons/AdminScaffolding/AdminScaffolding.jsx
 **/